
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
// passa a ser darrer video
const Chronicle = () => {

    const [multimedia, setMultimedia] = useState([]);
    const fetchMultimediaData = () => {
        fetch("https://clubolesapati.cat/API/apiMultimedia.php")
            .then(response => {
                return response.json()
            })
            .then(data => {
                setMultimedia(data[0]);
                console.log(multimedia);
            })

    }
    useEffect(() => {
    
        fetchMultimediaData(); console.log(multimedia);
    }, [])
    return (<> <h3 className="w-full text-medium md:text-4xl text-white lg:pt-12 my-auto lg:pl-4 mb-4"> <strong>Darrer vídeo</strong></h3>
        <div className='w-full p-3 hover:p-3 hover:-translate-y-2 transition-all duration-1000 '>
            <div className='rounded-lg border-2 hover:shadow-2xl'>
                <Link className='cursor-pointer' to={`/multimedia/${multimedia['multimediaCode']}-${multimedia['multimediaName']}#video`} onClick={() => {
                    document
                        .getElementById("video")
                        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}> <img width="199%"  alt={multimedia['multimediaName']} className='rounded-t-lg  min-w-48 aspect-[16/9]' src={"https://i.ytimg.com/vi/" + multimedia['multimediaCode'] + "/hqdefault.jpg?sqp=-oaymwE1CKgBEF5IVfKriqkDKAgBFQAAiEIYAXABwAEG8AEB-AH-CYAC0AWKAgwIABABGGUgXihOMA8=&rs=AOn4CLCsD9lHN43WnT0QDYb1GTCUirXKcw"}></img>
                </Link>
                <div className='w-1/2'></div>

                <div className="text-left font-bold flex justify-center capitalize">
                    <div className="w-full bg-green-600 p-4 text-slate-100  text-xs">
                        <Link className='cursor-pointer' to={`/multimedia/${multimedia['multimediaCode']}-${multimedia['multimediaName']}#video`} onClick={() => {
                            document
                                .getElementById("video")
                                ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }}>{multimedia['multimediaName']}</Link>
                    </div>
                </div>
            </div>
        </div></>
    )
}

export default Chronicle;